import React from 'react';
import ReactCountryFlag from 'react-country-flag'

let FlagButton = (props) => {
    return (
        <li className="nav-item">
            <button className="nav-link btn-magnify button-on-navbar"
                style={{ backgroundColor: "transparent", border: "none" }} onClick={() => {
                }}>

                <ReactCountryFlag
                    style={{ fontSize: 17, marginTop: 2 }}
                    countryCode={getCountryCode(props.countryScope)} />

                <p>
                    <span className="d-lg-none d-md-block" style={{ marginLeft: 5 }}>
                        País objetivo
                    </span>
                </p>
            </button>
        </li>
    );
}

let getCountryCode = (countryName) => {
    switch (countryName) {
        case "COLOMBIA":
            return "CO";
        case "PERU":
            return "PE";
        case "CANADA":
            return "CA";
        default:
            return "CO";
    }
}

export default FlagButton;